export default "__VITE_ASSET__zqIV0fw1__";